import React from 'react';
import styled from 'styled-components';
import AnimateOnScroll from '../AnimateOnScroll';

import Img1 from '../../assets/images/IMG_2836.JPG';
import Img2 from '../../assets/img/add/2.png';
import Img3 from '../../assets/images/image.png';

export default function Wings() {
  return (
    <Section id="wings">
      <div className="container">
        <HeaderRow className="flexSpaceCenter">
          <AnimateOnScroll animation="fadeUp" delay={0} duration={800}>
            <div>
              <Badge className="font13 semiBold">
                Our Educational Wings
              </Badge>
              <h3 className="font40 extraBold">Our Concours Preparation Programs</h3>
              <p className="font16">AFRIQ provides structured concours preparation for Medicine, Sciences, Arts, Technical Fields, and Polytechnic entrance exams. Our programs include targeted lessons, past-question drills, exam simulations, and personalized mentorship to build confidence and accuracy. We also offer STEM activities for primary school pupils and computer literacy programs for the less privileged.</p>
            </div>
          </AnimateOnScroll>
        </HeaderRow>

        <CardsWrap className="flexSpaceCenter">
          <AnimateOnScroll animation="fadeUp" delay={0} duration={800}>
            <Card>
              <CardHeader>
                <IconWrapper>
                  <span className="icon">⚕️</span>
                </IconWrapper>
                <h4 className="font22 extraBold">Medicine</h4>
              </CardHeader>
              <ImageWrapper>
                <MedicineImage src={Img1} alt="Medicine Preparation" />
                <ImageOverlay />
              </ImageWrapper>
              <CardContent>
                <p className="font15">We prepare students for medical entrance exams through targeted lessons in Biology, Chemistry, Physics, and more. The program includes past-question drills, exam simulations, and mentorship to build confidence and accuracy.</p>
                <Tag className="purpleBg whiteColor">#Medicine</Tag>
              </CardContent>
            </Card>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fadeUp" delay={200} duration={800}>
            <Card>
              <CardHeader>
                <IconWrapper>
                  <span className="icon">🔬</span>
                </IconWrapper>
                <h4 className="font22 extraBold">Sciences</h4>
              </CardHeader>
              <ImageWrapper>
                <img src={Img2} alt="Sciences Preparation" />
                <ImageOverlay />
              </ImageWrapper>
              <CardContent>
                <p className="font15">Our science preparation program strengthens students in key scientific subjects and analytical skills required for science-based entrance exams. It offers structured lessons, revisions, and concept-focused practice.</p>
                <Tag className="purpleBg whiteColor">#Sciences</Tag>
              </CardContent>
            </Card>
          </AnimateOnScroll>

          <AnimateOnScroll animation="fadeUp" delay={400} duration={800}>
            <Card>
              <CardHeader>
                <IconWrapper>
                  <span className="icon">📚</span>
                </IconWrapper>
                <h4 className="font22 extraBold">Arts & Technical</h4>
              </CardHeader>
              <ArtsTechnicalImageWrapper>
                <ArtsTechnicalImage src={Img3} alt="Arts & Technical Preparation" />
                <ImageOverlay />
              </ArtsTechnicalImageWrapper>
              <CardContent>
                <p className="font15">We support arts candidates with intensive training in English, Literature, History, and Geography. We also provide technical preparation covering Technical Drawing, Mathematics, Physics, and applied concepts for polytechnic and technical entrance exams.</p>
                <Tag className="goldBg darkColor">#Arts & Technical</Tag>
              </CardContent>
            </Card>
          </AnimateOnScroll>
        </CardsWrap>
      </div>
    </Section>
  );
}

const Section = styled.section`
  padding: 120px 0;
  background: #f8f8ff;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 80px 0;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 20%, rgba(75, 46, 131, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(221, 166, 31, 0.03) 0%, transparent 50%);
    z-index: 1;
  }
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #4b2e83;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(75, 46, 131, 0.3);
  }
  
  .badge-icon {
    font-size: 14px;
  }
`;

const HeaderRow = styled.div`
  margin-bottom: 80px;
  position: relative;
  z-index: 2;
  max-width: 900px;
  
  @media (max-width: 768px) {
    margin-bottom: 50px;
  }
  
  h3 {
    margin-bottom: 15px;
    color: #4b2e83;
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    line-height: 1.3;
  }
  
  p {
    color: #000000;
    line-height: 1.7;
    max-width: 100%;
    font-size: clamp(0.9rem, 2vw, 1rem);
  }
  
  @media (max-width: 768px) {
    text-align: center;
    
    p {
      max-width: 100%;
    }
  }
`;

const CardsWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  align-items: stretch;
  position: relative;
  z-index: 2;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  @media (max-width: 480px) {
    gap: 18px;
  }
`;

const Card = styled.div`
  background: #ffffff;
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(75, 46, 131, 0.15);
  border: 1px solid rgba(75, 46, 131, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #000000;
  opacity: 0;
  transform: translateY(30px);
  animation: cardEntrance 0.8s ease-out forwards;
  padding: 30px;
  
  @media (max-width: 768px) {
    padding: 25px;
    border-radius: 14px;
  }
  
  @media (max-width: 480px) {
    padding: 20px;
    border-radius: 12px;
  }
  
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }

  &:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 25px 60px rgba(75, 46, 131, 0.25);
    border-color: #dda61f;
  }

  @keyframes cardEntrance {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CardHeader = styled.div`
  padding: 25px 25px 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  
  @media (max-width: 768px) {
    padding: 20px 20px 12px;
    gap: 12px;
  }
  
  @media (max-width: 480px) {
    padding: 18px 18px 10px;
    gap: 10px;
  }
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  border-radius: 50%;
  background: #4b2e83;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(75, 46, 131, 0.3);
  transition: all 0.3s ease;
  
  .icon {
    font-size: 24px;
    color: #ffffff;
  }
  
  @media (max-width: 480px) {
    width: 45px;
    height: 45px;
    min-width: 45px;
    min-height: 45px;
    
    .icon {
      font-size: 20px;
    }
  }
  
  ${Card}:hover & {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 12px 35px rgba(75, 46, 131, 0.4);
  }
`;

const ImageWrapper = styled.div`
  width: calc(100% - 50px);
  height: 200px;
  overflow: hidden;
  position: relative;
  margin: 0 25px 20px;
  border-radius: 12px;
  background: #f5f5f5;
  
  @media (max-width: 768px) {
    height: 180px;
    width: calc(100% - 40px);
    margin: 0 20px 15px;
  }
  
  @media (max-width: 480px){
    height: 160px;
    width: calc(100% - 36px);
    margin: 0 18px 12px;
    border-radius: 10px;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    display: block;
    margin: 0;
    padding: 0;
  }
  
  ${Card}:hover & img {
    transform: scale(1.1);
  }
  
`;

const MedicineImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: block;
  margin: 0;
  padding: 0;
  
  ${Card}:hover & {
    transform: scale(1.1);
  }
  
  ${ImageWrapper}:hover & {
    transform: scale(1.1);
  }
`;

const ArtsTechnicalImageWrapper = styled(ImageWrapper)`
  height: 300px;
  
  @media (max-width: 768px) {
    height: 280px;
  }
  
  @media (max-width: 480px) {
    height: 260px;
  }
`;

const ArtsTechnicalImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: block;
  margin: 0;
  padding: 0;
  
  ${Card}:hover & {
    transform: scale(1.05);
  }
  
  ${ArtsTechnicalImageWrapper}:hover & {
    transform: scale(1.05);
  }
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(75, 46, 131, 0.1) 0%, rgba(75, 46, 131, 0.1) 50%, rgba(75, 46, 131, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  
  ${Card}:hover & {
    opacity: 1;
  }
`;

const CardContent = styled.div`
  padding: 0 25px 25px;
  
  h4 {
    font-size: clamp(1.125rem, 2.5vw, 1.25rem);
    margin-bottom: 12px;
    color: #4b2e83;
  }
  
  p {
    color: #000000;
    line-height: 1.7;
    margin-bottom: 20px;
    font-size: clamp(0.85rem, 2vw, 0.9rem);
  }
  
  @media (max-width: 768px) {
    padding: 0 20px 20px;
  }
  
  @media (max-width: 480px) {
    padding: 0 18px 18px;
    
    p {
      margin-bottom: 15px;
    }
  }
`;

const Tag = styled.span`
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }
`;
